import { render } from "./BroadcastTimes.vue?vue&type=template&id=21f85b4a&scoped=true"
import script from "./BroadcastTimes.vue?vue&type=script&lang=js"
export * from "./BroadcastTimes.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-21f85b4a"

export default script